/**
 * THE REVIEW BUILD.
 *
 * `pnpm --filter @ofmos/web dev:review` sets `VITE_FIXTURES=1`, which makes
 * main.tsx hand the app the FixtureClient instead of the HTTP client. The whole
 * product then runs on fixture data with no server, no database and no login -
 * which is what looking at a screen needs: real screens, real density, real
 * states, nothing to set up before opening them.
 *
 * It changes exactly two things and says so out loud:
 *  - the data client (fixtures, seeded dense enough to judge a table),
 *  - the live-update stream is not opened (there is no server to stream from).
 *
 * Everything else - components, tokens, routes, layouts - is the real app. There
 * is no design switch on top of it any more: the design IS the token layer, so a
 * review build shows exactly what production shows.
 */
export const IS_REVIEW_BUILD = import.meta.env['VITE_FIXTURES'] === '1';
